import { observable } from "mobx";
import { copy } from "../../../utils/data";
import { Address } from "../../profile";


export default class UserInfo {
  @observable firstName: string;
  @observable lastName: string;
  @observable submitted: Date;
  @observable address: Address;
  @observable email: string;
  @observable userId: string;
  @observable phone: string;
  @observable veteran: boolean;
  @observable homeless: boolean;
  @observable residentNYCHA: boolean;
  @observable residentLocation: string;
  @observable exOffender: boolean;
  @observable disabled: boolean;

  constructor(ui?: UserInfo) {
    this.firstName = this.lastName = this.email = this.userId = this.residentLocation = this.phone = "";
    this.submitted = new Date();
    this.veteran = this.homeless = this.residentNYCHA = this.exOffender = this.disabled = false;
    this.address = new Address();
    if (ui) {
      copy(ui, this, ["submitted","address"]);
      this.submitted = new Date(ui.submitted.valueOf());
      if (ui.address) {
        copy(ui.address, this.address);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/models/client/hudsonyards/userInfo.ts